import styled from "styled-components";

const Button = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  position: relative;
  border-radius: 10px;

  justify-content: center;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  pointer-events: auto;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  font-weight: 600;
  white-space: nowrap;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s ease-in-out;

  background: ${({ theme }) => theme.color.background};
  color: ${({ theme }) => theme.color.backgroundText};
`

export default Button